import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card } from './ui/card';
import { CheckCircle2, Circle, X } from 'lucide-react';
import api from '../lib/api';
import useAuthStore from '../lib/auth-store';

export function SetupProgressCard() {
  const { user } = useAuthStore();
  const [progress, setProgress] = useState(null);
  const [dismissedLocally, setDismissedLocally] = useState(false);

  useEffect(() => {
    if (user?.role !== 'iso' || user?.is_sandbox) return;
    api.getSetupProgress().then(setProgress).catch(() => {});
  }, [user]);

  if (user?.role !== 'iso' || user?.is_sandbox) return null;
  if (!progress || progress.dismissed || dismissedLocally) return null;
  if (progress.completed_count >= progress.total_count) return null;

  const handleDismiss = async () => {
    setDismissedLocally(true);
    try { await api.dismissSetupProgress(); } catch {}
  };

  const pct = Math.round((progress.completed_count / progress.total_count) * 100);

  return (
    <Card className="p-5 border-emerald-200 bg-emerald-50/40" data-testid="setup-progress-card">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-1">
            <h3 className="font-semibold text-sm">Finish setting up your agency</h3>
            <span className="text-xs text-muted-foreground">{progress.completed_count}/{progress.total_count} complete</span>
          </div>
          <div className="w-full h-1.5 bg-emerald-100 rounded-full overflow-hidden mb-3">
            <div className="h-full bg-emerald-500 rounded-full transition-all" style={{ width: `${pct}%` }} />
          </div>
          <div className="grid gap-1.5 sm:grid-cols-2">
            {progress.steps.map((step) => (
              <Link
                key={step.key}
                to={step.href}
                className="flex items-center gap-2 text-sm hover:underline"
                data-testid={`setup-step-${step.key}`}
              >
                {step.completed ? (
                  <CheckCircle2 className="h-4 w-4 text-emerald-600 flex-shrink-0" />
                ) : (
                  <Circle className="h-4 w-4 text-muted-foreground flex-shrink-0" />
                )}
                <span className={step.completed ? 'text-muted-foreground line-through' : ''}>{step.label}</span>
              </Link>
            ))}
          </div>
        </div>
        <button onClick={handleDismiss} className="text-muted-foreground hover:text-foreground" data-testid="setup-progress-dismiss-btn">
          <X className="h-4 w-4" />
        </button>
      </div>
    </Card>
  );
}
